<template>
  <div class="app-container">
    <!-- 麦粒医生统计 -->
    <el-card style="border: 1px solid #DCDFE6;border-radius: 0;">
      <div class="btn-group" style="margin-bottom: 20px;">
        <!-- 切换菜单 -->
        <el-button-group>
          <el-button
            :type="currentTab === '0' ? 'primary' : ''"
            size="small"
            @click="siwtchTab('0')"
          >
            麦粒直播统计
          </el-button>
          <el-button
            :type="currentTab === '1' ? 'primary' : ''"
            size="small"
            @click="siwtchTab('1')"
          >
            往期回顾统计
          </el-button>
          <el-button
            :type="currentTab === '2' ? 'primary' : ''"
            size="small"
            @click="siwtchTab('2')"
          >
            视频课程统计
          </el-button>
          <el-button
            :type="currentTab === '3' ? 'primary' : ''"
            size="small"
            @click="siwtchTab('3')"
          >
            病例档案统计
          </el-button>
          <el-button
            :type="currentTab === '4' ? 'primary' : ''"
            size="small"
            @click="siwtchTab('4')"
          >
            超人圈统计
          </el-button>
          <el-button
            :type="currentTab === '5' ? 'primary' : ''"
            size="small"
            @click="siwtchTab('5')"
          >
            APP其他页面统计
          </el-button>
        </el-button-group>
        <!-- 时间菜单 -->
        <div class="block">
          <el-button-group>
            <el-button
              :type="currentDateTab === '0' ? 'primary' : ''"
              size="small"
              @click="siwtchDateTab('0')"
            >
              今天
            </el-button>
            <el-button
              :type="currentDateTab === '1' ? 'primary' : ''"
              size="small"
              @click="siwtchDateTab('1')"
            >
              一周
            </el-button>
            <el-button
              :type="currentDateTab === '2' ? 'primary' : ''"
              size="small"
              style="border-right: 0; border-radius: 0"
              @click="siwtchDateTab('2')"
            >
              30天
            </el-button>
          </el-button-group>
          <el-date-picker
            v-model="daterange"
            size="small"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="border-radius: 0 3px 3px 0"
          />
        </div>
      </div>

      <!-- 柱状图 -->
      <el-row id="line-box">
        <div v-if="currentTab === '0'" id="chartLine1-1"></div>
        <div v-if="currentTab === '0'" id="chartLine1-2"></div>
        <div v-if="currentTab === '1'" id="chartLine2-1"></div>
        <div v-if="currentTab === '2'" id="chartLine3-1"></div>
        <div v-if="currentTab === '2'" id="chartLine3-2"></div>
        <div v-if="currentTab === '3'" id="chartLine4-1"></div>
        <div v-if="currentTab === '4'" id="chartLine5-1"></div>
        <div v-if="currentTab === '4'" id="chartLine5-2"></div>
        <div v-if="currentTab === '5'" id="chartLine6-1"></div>
        <div v-if="currentTab === '5'" id="chartLine6-2"></div>
        <div v-if="currentTab === '5'" id="chartLine6-3"></div>
        <div v-if="currentTab === '5'" id="chartLine6-4"></div>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentTab: '0',
      currentDateTab: '0',
      daterange: '',
      chartLine11: '',
      chartLineOption11: {},
      chartLine12: '',
      chartLineOption12: {},
      chartLine21: '',
      chartLineOption21: {},
      chartLine31: '',
      chartLineOption31: {},
      chartLine32: '',
      chartLineOption32: {},
      chartLine41: '',
      chartLineOption41: {},
      chartLine51: '',
      chartLineOption51: {},
      chartLine52: '',
      chartLineOption52: {},
      chartLine61: '',
      chartLineOption61: {},
      chartLine62: '',
      chartLineOption62: {},
      chartLine63: '',
      chartLineOption63: {},
      chartLine64: '',
      chartLineOption64: {}
    }
  },
  computed: {
    getSidebarStatus() {
      return this.$store.state.app.sidebar.opened
    }
  },
  watch: {
    getSidebarStatus() {
      setTimeout(() => {
        switch (this.currentTab) {
          case '0':
            this.chartLine11.resize()
            this.chartLine12.resize()
            break
          case '1':
            this.chartLine21.resize()
            break
          case '2':
            this.chartLine31.resize()
            this.chartLine32.resize()
            break
          case '3':
            this.chartLine41.resize()
            break
          case '4':
            this.chartLine51.resize()
            this.chartLine52.resize()
            break
          case '5':
            this.chartLine61.resize()
            this.chartLine62.resize()
            this.chartLine63.resize()
            this.chartLine64.resize()
            break
        }
      }, 300)
    }
  },
  mounted() {
    this.drawLine('0')
  },
  methods: {
    /**
     * 切换菜单
     */
    siwtchTab(index) {
      this.currentTab = index
      setTimeout(() => {
        this.drawLine(index)
      }, 300)
    },
    /**
     * 切换日期
     */
    siwtchDateTab(index) {
      this.currentDateTab = index
    },
    /**
     * 生成折线图
     */
    drawLine(index) {
      switch (index) {
        case '0':
          // 直播创建数量
          this.chartLine11 = this.$echarts.init(
            document.getElementById('chartLine1-1')
          )
          this.chartLineOption11 = {
            title: {
              text: '直播创建数量',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  130,
                  82,
                  55,
                  50,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine11.setOption(this.chartLineOption11)

          // 直播观看人数
          this.chartLine12 = this.$echarts.init(
            document.getElementById('chartLine1-2')
          )
          this.chartLineOption12 = {
            title: {
              text: '直播观看人数',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine12.setOption(this.chartLineOption12)
          break
        case '1':
          // 往期回顾播放量
          this.chartLine21 = this.$echarts.init(
            document.getElementById('chartLine2-1')
          )
          this.chartLineOption21 = {
            title: {
              text: '往期回顾播放量',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine21.setOption(this.chartLineOption21)
          break
        case '2':
          // 视频课程发布量
          this.chartLine31 = this.$echarts.init(
            document.getElementById('chartLine3-1')
          )
          this.chartLineOption31 = {
            title: {
              text: '视频课程发布量',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine31.setOption(this.chartLineOption31)

          // 视频课程播放量
          this.chartLine32 = this.$echarts.init(
            document.getElementById('chartLine3-2')
          )
          this.chartLineOption32 = {
            title: {
              text: '视频课程播放量',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine32.setOption(this.chartLineOption32)
          break
        case '3':
          // 视频课程发布量
          this.chartLine41 = this.$echarts.init(
            document.getElementById('chartLine4-1')
          )
          this.chartLineOption41 = {
            title: {
              text: '病例档案',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine41.setOption(this.chartLineOption41)
          break
        case '4':
          // 视频课程发布量
          this.chartLine51 = this.$echarts.init(
            document.getElementById('chartLine5-1')
          )
          this.chartLineOption51 = {
            title: {
              text: '超人圈发布量',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine51.setOption(this.chartLineOption51)

          // 视频课程播放量
          this.chartLine52 = this.$echarts.init(
            document.getElementById('chartLine5-2')
          )
          this.chartLineOption52 = {
            title: {
              text: '超人圈播放量',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine52.setOption(this.chartLineOption52)
          break
        case '5':
          // “热门讨论”浏览量
          this.chartLine61 = this.$echarts.init(
            document.getElementById('chartLine6-1')
          )
          this.chartLineOption61 = {
            title: {
              text: '“热门讨论”浏览量',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine61.setOption(this.chartLineOption61)

          // “精彩直播”浏览量
          this.chartLine62 = this.$echarts.init(
            document.getElementById('chartLine6-2')
          )
          this.chartLineOption62 = {
            title: {
              text: '“精彩直播”浏览量',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine62.setOption(this.chartLineOption62)

          // “好文推荐”浏览量
          this.chartLine63 = this.$echarts.init(
            document.getElementById('chartLine6-3')
          )
          this.chartLineOption63 = {
            title: {
              text: '“好文推荐”浏览量',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine63.setOption(this.chartLineOption63)

          // “活动广场”浏览量
          this.chartLine64 = this.$echarts.init(
            document.getElementById('chartLine6-4')
          )
          this.chartLineOption64 = {
            title: {
              text: '“活动广场”浏览量',
              x: 'center',
              top: '5%'
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: [
                '0:00',
                '1:00',
                '2:00',
                '3:00',
                '4:00',
                '5:00',
                '6:00',
                '7:00',
                '8:00',
                '9:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
                '24:00'
              ]
            },
            yAxis: {
              type: 'value'
            },
            grid: {
              top: '25%',
              bottom: '15%',
              left: '2%',
              right: '2%',
              backgroundColor: 'rgba(0,0,0,0)',
              borderWidth: 1,
              borderColor: '#ccc'
            },
            series: [
              {
                data: [
                  82,
                  92,
                  91,
                  94,
                  94,
                  120,
                  120,
                  130,
                  82,
                  55,
                  50,
                  82,
                  62,
                  120,
                  50,
                  43,
                  130,
                  82,
                  92,
                  130,
                  91,
                  94,
                  120,
                  130,
                  130
                ],
                type: 'line',
                areaStyle: {},
                itemStyle: {
                  normal: {
                    color: '#409EFF'
                  }
                }
              }
            ]
          }
          this.chartLine64.setOption(this.chartLineOption64)
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.block {
  display: flex;
  align-items: center;
}

#chartLine1-1,
#chartLine1-2,
#chartLine2-1,
#chartLine3-1,
#chartLine3-2,
#chartLine4-1,
#chartLine5-1,
#chartLine5-2,
#chartLine6-1,
#chartLine6-2,
#chartLine6-3,
#chartLine6-4 {
  width: 100%;
  height: 300px;
  margin-bottom: 20px;
}
</style>
